"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _notifications = require("@/api/notifications/notifications");
var _app = require("@/store/modules/app");
var _tagsView = require("@/store/modules/tags-view");
var _router = _interopRequireDefault(require("@/router"));
var _vuexModuleDecorators = require("vuex-module-decorators");
var _utils = require("@/utils");
var _index = _interopRequireDefault(require("@/components/FileUpload/index.vue"));
var _common = require("@/api/common");
var _zones = require("@/api/zones");
var _divisions = require("@/api/divisions");
var _employee = require("@/api/employee");
var _zmLocations = require("@/api/zmLocations");
var _rmLocations = require("@/api/rmLocations");
var _amLocations = require("@/api/amLocations");
var _mrLocations = require("@/api/mrLocations");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, _notifications.defaultNotificationsData);
    this.loading = false;
    this.rules = {
      title: [{
        required: true,
        trigger: "blur"
      }, {
        min: 3,
        max: 150,
        message: "Length should be 3 to 150",
        trigger: "blur"
      }],
      message: [{
        required: true,
        trigger: "blur"
      }, {
        min: 3,
        max: 250,
        message: "Length should be 3 to 250",
        trigger: "blur"
      }]
    };
    this.image = [];
    this.typeList = ["Division", "Zone", "ZMLocation", "RMLocation", "AMLocation", "MRLocation", "EmployeesRole", "Not Uploaded Image", "Not Changed Rank", "Rank Increased", "Rank Decreased", "App Opened"];
    this.pages = [{
      label: "Announcement",
      key: "announcement"
    }, {
      label: "HomePage - MyZone",
      key: "dashboard - MyZone"
    }, {
      label: "HomePage - All India",
      key: "dashboard - All India"
    }, {
      label: "Profile",
      key: "profile"
    }, {
      label: "FAQs",
      key: "faqs"
    }, {
      label: "Rules",
      key: "rules"
    }];
  }
  get lang() {
    return _app.AppModule.language;
  }
  created() {
    this.getAppVersionList();
    this.getDivisions();
    this.getZones();
    this.getEmployeesRoles();
    this.getLastSevenDates();
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, _notifications.defaultNotificationsData);
    }
    // Why need to make a copy of this.$route here?
    // Because if you enter this page and quickly switch tag, may be in the execution of this.setTagsViewTitle function, this.$route is no longer pointing to the current page
    // https://github.com/PanJiaChen/vue-element-admin/issues/1221
    this.tempTagView = Object.assign({}, this.$route);
  }
  async getZones() {
    try {
      const listQuery = {
        sort: "name,ASC"
      };
      const zones = await (0, _zones.getZones)((0, _utils.getQuery)(listQuery));
      this.zoneList = zones;
      return zones;
    } catch (err) {
      Promise.reject(err);
    }
  }
  getLastSevenDates() {
    const today = new Date();
    const lastSevenDates = [];
    for (let i = 6; i > 0; i--) {
      const date = new Date(today);
      date.setDate(today.getDate() - i);
      // Format the date as 'DD-MM-YYYY'
      const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
      lastSevenDates.push(formattedDate);
    }
    this.lastSevenDates = lastSevenDates;
    return lastSevenDates;
  }
  async getDivisions() {
    try {
      const listQuery = {
        sort: "name,ASC"
      };
      const divisions = await (0, _divisions.getDivisions)((0, _utils.getQuery)(listQuery));
      this.divisionList = divisions;
      return divisions;
    } catch (err) {
      Promise.reject(err);
    }
  }
  async getEmployeesRoles() {
    try {
      const employeesRoles = await (0, _employee.getEmployeeRoles)();
      this.employeesRoleList = employeesRoles;
      return employeesRoles;
    } catch (err) {
      Promise.reject(err);
    }
  }
  async getZMLocations(divisionIds) {
    try {
      const query = {
        divisionId: divisionIds,
        sort: "name,ASC",
        filter: {
          divisionId: "in"
        }
      };
      const zmLocations = await (0, _zmLocations.getZMLocations)((0, _utils.getQuery)(query));
      this.zmLocationList = zmLocations;
      return zmLocations;
    } catch (err) {
      Promise.reject(err);
    }
  }
  async getRMLocations(divisionIds) {
    try {
      const query = {
        "zmLocation.divisionId": divisionIds,
        sort: "name,ASC",
        filter: {
          "zmLocation.divisionId": "in"
        }
      };
      const rmLocations = await (0, _rmLocations.getRMLocations)((0, _utils.getQuery)(query));
      this.rmLocationList = rmLocations;
      await this.getZMLocations(divisionIds);
      await this.getRMLocationUnchangeRank(divisionIds);
      await this.getRMLocationUpRank(divisionIds);
      await this.getRMLocationDownRank(divisionIds);
      return this.rmLocationList;
    } catch (err) {
      Promise.reject(err);
    }
  }
  async getAMLocations(rmLocationIds) {
    try {
      const query = {
        rmLocationId: rmLocationIds,
        sort: "name,ASC",
        filter: {
          rmLocationId: "in"
        }
      };
      const amLocations = await (0, _amLocations.getAMLocations)((0, _utils.getQuery)(query));
      this.amLocationList = amLocations;
      return this.amLocationList;
    } catch (err) {
      Promise.reject(err);
    }
  }
  async getMRLocations(amLocationIds) {
    try {
      const query = {
        amLocationId: amLocationIds,
        sort: "name,ASC",
        filter: {
          amLocationId: "in"
        }
      };
      const mrLocations = await (0, _mrLocations.getMRLocations)((0, _utils.getQuery)(query));
      this.mrLocationList = mrLocations;
      return this.mrLocationList;
    } catch (err) {
      Promise.reject(err);
    }
  }
  async getRMLocationUnchangeRank(divisionIds) {
    try {
      const query = {
        divisionId: divisionIds,
        diffInAllIndiaRank: 0,
        monthWeek: "janWeek4",
        sort: "rmLocation.name,ASC",
        filter: {
          divisionId: "in",
          diffInAllIndiaRank: "eq",
          monthWeek: "eq"
        }
      };
      const rmLocationScores = await (0, _rmLocations.getRMLocationUnchangeRank)((0, _utils.getQuery)(query));
      this.rmLocationUnchangeRankList = rmLocationScores.map(rmLocationScore => rmLocationScore.rmLocation);
      return this.rmLocationUnchangeRankList;
    } catch (err) {
      Promise.reject(err);
    }
  }
  async getRMLocationUpRank(divisionIds) {
    try {
      const query = {
        divisionId: divisionIds,
        diffInAllIndiaRank: 0,
        monthWeek: "janWeek4",
        sort: "rmLocation.name,ASC",
        filter: {
          divisionId: "in",
          diffInAllIndiaRank: "gt",
          monthWeek: "eq"
        }
      };
      const rmLocationScores = await (0, _rmLocations.getRMLocationUnchangeRank)((0, _utils.getQuery)(query));
      this.rmLocationUpRankList = rmLocationScores.map(rmLocationScore => rmLocationScore.rmLocation);
      return this.rmLocationUpRankList;
    } catch (err) {
      Promise.reject(err);
    }
  }
  async getRMLocationDownRank(divisionIds) {
    try {
      const query = {
        divisionId: divisionIds,
        diffInAllIndiaRank: 0,
        monthWeek: "janWeek4",
        sort: "rmLocation.name,ASC",
        filter: {
          divisionId: "in",
          diffInAllIndiaRank: "lt",
          monthWeek: "eq"
        }
      };
      const rmLocationScores = await (0, _rmLocations.getRMLocationUnchangeRank)((0, _utils.getQuery)(query));
      this.rmLocationDownRankList = rmLocationScores.map(rmLocationScore => rmLocationScore.rmLocation);
      return this.rmLocationDownRankList;
    } catch (err) {
      Promise.reject(err);
    }
  }
  async fetchData(id) {
    try {
      const data = await (0, _notifications.getNotificationsById)(id);
      delete data.createdTimestamp;
      delete data.updatedTimestamp;
      this.formData = data;
      if (data.image) {
        this.image.push({
          url: data.image
        });
      }
      // Just for test
      const title = this.formData.title ? this.formData.title : "";
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
      if (!this.formData.divisionId) {
        this.formData.divisionId = [];
      }
      if (!this.formData.zoneId) {
        this.formData.zoneId = [];
      }
      if (!this.formData.zmLocationId) {
        this.formData.zmLocationId = [];
      }
      if (!this.formData.regionId) {
        this.formData.regionId = [];
      }
      if (!this.formData.amLocationId) {
        this.formData.amLocationId = [];
      }
      if (!this.formData.mrLocationId) {
        this.formData.mrLocationId = [];
      }
      if (!this.formData.employeeRole) {
        this.formData.employeeRole = [];
      }
      if (!this.formData.employeeRoleId) {
        this.formData.employeeRoleId = [];
      }
      if (this.formData.divisionId.length) {
        this.getRMLocations(this.formData.divisionId);
        this.getZMLocations(this.formData.divisionId);
      }
      if (this.formData.regionId.length) {
        this.getAMLocations(this.formData.regionId);
      }
      if (this.formData.amLocationId.length) {
        this.getMRLocations(this.formData.amLocationId);
      }
    } catch (err) {
      Promise.reject(err);
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      _tagsView.TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  async sendToAllToggled() {
    if (this.formData.sendToAll) {
      this.$confirm("Are you sure want to send notification to All users?", "Attention!", {
        confirmButtonText: "Yes, I know what I'm doing",
        confirmButtonClass: "el-button--success",
        cancelButtonText: this.$tc("table.cancel"),
        cancelButtonClass: "el-button--danger",
        type: "error"
      }).then(async confirm => {
        // let it confirm
        // clear other dropdowns
        this.formData.appVersion = undefined;
        this.formData.type = null;
        this.formData.divisionId = [];
        this.formData.zoneId = [];
        this.formData.zmLocationId = [];
        this.formData.regionId = [];
        this.formData.amLocationId = [];
        this.formData.mrLocationId = [];
        this.formData.employeeRole = [];
        this.formData.employeeRoleId = [];
      }).catch(_ => {
        this.formData.sendToAll = false;
      });
    } else {
      await this.getDivisions();
      await this.getZones();
      await this.getEmployeesRoles();
    }
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      if (this.isEdit) {
        // console.log(this.formData);
        this.formData.id = null;
        // await updateNotifications(this.formData.id, this.formData);
      }
      if (this.formData.type === "Not Uploaded Image") {
        this.formData.sendUploadImage = true;
        this.formData.employeeRoleId = [2];
        this.formData.sendToAll = false;
      }
      // console.log(this.formData);
      await (0, _notifications.createNotifications)(this.formData);
      this.$notify({
        title: "Success",
        message: "Data saved successfully",
        type: "success",
        duration: 2000
      });
      _router.default.push("/notifications/list");
    } catch (err) {
      this.loading = false;
    }
  }
  async getAppVersionList() {
    try {
      this.appVersionList = await (0, _common.getAppVersions)();
    } catch (err) {
      Promise.reject(err);
    }
  }
  imageUpload(file) {
    this.formData.image = file.response;
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], default_1.prototype, "isEdit", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: []
})], default_1.prototype, "appVersionList", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: []
})], default_1.prototype, "zmLocationList", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: []
})], default_1.prototype, "rmLocationList", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: []
})], default_1.prototype, "amLocationList", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: []
})], default_1.prototype, "mrLocationList", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: []
})], default_1.prototype, "rmLocationUnchangeRankList", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: []
})], default_1.prototype, "rmLocationUpRankList", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: []
})], default_1.prototype, "rmLocationDownRankList", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: []
})], default_1.prototype, "lastSevenDates", void 0);
(0, _tslib.__decorate)([_vuexModuleDecorators.Action], default_1.prototype, "saveForm", null);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: "NotificationsDetail",
  components: {
    FileUpload: _index.default
  }
})], default_1);
var _default = exports.default = default_1;